
import { Injectable } from "@angular/core";
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { EMPTY, Observable, throwError } from "rxjs";
import { catchError } from 'rxjs/operators';
import { NotifierService } from 'angular-notifier';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {

  private isRedirectingToLogin = false;

  constructor(
    private readonly notifierService: NotifierService,
    private readonly router: Router,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const hideToast = sessionStorage.getItem('hide-toast');
    const isCepRequest = request.url.includes('viacep.com')
      || request.url.includes('brasilapi.com.br')
      || request.url.includes('opencep.com');
    const isAuthEndpoint = request.url.includes('/v1/authenticate')
      || request.url.includes('/v1/staff/authenticate');

    if (!isCepRequest && !isAuthEndpoint && this.isLocalTokenExpired()) {
      this.redirectToLogin();
      return EMPTY;
    }

    return next.handle(request).pipe(
      catchError((error) => {
        if (
          error instanceof HttpErrorResponse
          && error.status === 401
          && !isCepRequest
          && !isAuthEndpoint
        ) {
          this.redirectToLogin();
          return throwError(error);
        }

        if (!isCepRequest && error.error?.errors && !hideToast) {
          error.error.errors.forEach(error => {
            if (error != '') {
              this.notifierService.notify('error', error);
            }
          });
        }
        return throwError(error);
      })
    )
  }

  private isLocalTokenExpired(): boolean {
    const token = localStorage.getItem('id_token');
    const expiresAt = localStorage.getItem('token-expiresAt');

    if (!token || !expiresAt) {
      return false;
    }

    const expirationDate = new Date(expiresAt);
    if (isNaN(expirationDate.getTime())) {
      return false;
    }

    return expirationDate <= new Date();
  }

  private redirectToLogin(): void {
    if (this.isRedirectingToLogin) {
      return;
    }
    this.isRedirectingToLogin = true;

    this.notifierService.notify('error', 'Sua sessão expirou, faça o login novamente.');

    const currentUrl = this.router.url;
    const isAdmin = currentUrl.includes('/admin');
    const tenant = currentUrl.split('/').filter(Boolean)[0];

    localStorage.clear();

    const loginPath = isAdmin
      ? `${tenant ? '/' + tenant : ''}/admin/login`
      : `${tenant ? '/' + tenant : ''}/login`;

    this.router
      .navigate([loginPath], { queryParams: { returnUrl: currentUrl } })
      .finally(() => {
        this.isRedirectingToLogin = false;
      });
  }
}